import React from 'react';
import Teams from '../containers/Teams';
import Members from '../containers/Members';
// import Contact from '../containers/Contact';
import '../styles/Team.css';

export default class Team extends React.Component{
    render(){
      return (
        <div className="Team" id='Team'>
            <div className="team-background-container">
                {/* Animated galaxy background elements - optimized */}
                
                {/* Blobs */}
                <div className="animated-blob blob1"></div>
                <div className="animated-blob blob2"></div>
                <div className="animated-blob blob3"></div>
                <div className="animated-blob blob4"></div>
                <div className="animated-blob blob5"></div>
                <div className="animated-blob blob6"></div>
                
                {/* Nebula effects */}
                <div className="nebula nebula1"></div>
                <div className="nebula nebula2"></div>
                <div className="nebula nebula3"></div>
                <div className="nebula nebula4"></div>
                <div className="nebula nebula5"></div>
                
                {/* Animated rings */}
                <div className="animated-ring ring1"></div>
                <div className="animated-ring ring2"></div>
                <div className="animated-ring ring3"></div>
                <div className="animated-ring ring4"></div>
                
                {/* Stars */}
                <div className="star star1"></div>
                <div className="star star2"></div>
                <div className="star star3"></div>
                <div className="star star4"></div>
                <div className="star star5"></div>
                <div className="star star6"></div>
                <div className="star star7"></div>
                <div className="star star8"></div>
                <div className="star star9"></div>
                <div className="star star10"></div>
                <div className="star star11"></div>
                <div className="star star12"></div>
                <div className="star star13"></div>
                <div className="star star14"></div>
                <div className="star star15"></div>
                <div className="star star16"></div>
                <div className="star star17"></div>
                <div className="star star18"></div>
                <div className="star star19"></div>
                <div className="star star20"></div>
                <div className="star star21"></div>
                <div className="star star22"></div>
                <div className="star star23"></div>
                <div className="star star24"></div>
                <div className="star star25"></div>
                <div className="star star26"></div>
                <div className="star star27"></div>
                <div className="star star28"></div>
                <div className="star star29"></div>
                <div className="star star30"></div>
                <div className="star star31"></div>
                <div className="star star32"></div>
                <div className="star star33"></div>
                <div className="star star34"></div>
                <div className="star star35"></div>
                <div className="star star36"></div>
                <div className="star star37"></div>
                <div className="star star38"></div>
                <div className="star star39"></div>
                <div className="star star40"></div>
                <div className="star star41"></div>
                <div className="star star42"></div>
                <div className="star star43"></div>
                <div className="star star44"></div>
                <div className="star star45"></div>
                <div className="star star46"></div>
                <div className="star star47"></div>
                <div className="star star48"></div>
                <div className="star star49"></div>
                <div className="star star50"></div>
                
                {/* Bright stars */}
                <div className="bright-star bright-star1"></div>
                <div className="bright-star bright-star2"></div>
                <div className="bright-star bright-star3"></div>
                <div className="bright-star bright-star4"></div>
                <div className="bright-star bright-star5"></div>
                <div className="bright-star bright-star6"></div>
                <div className="bright-star bright-star7"></div>
                <div className="bright-star bright-star8"></div>
                <div className="bright-star bright-star9"></div>
                <div className="bright-star bright-star10"></div>
                <div className="bright-star bright-star11"></div>
                <div className="bright-star bright-star12"></div>
                <div className="bright-star bright-star13"></div>
                <div className="bright-star bright-star14"></div>
                <div className="bright-star bright-star15"></div>
                <div className="bright-star bright-star16"></div>
                
                {/* Shooting stars */}
                <div className="shooting-star shooting-star1"></div>
                <div className="shooting-star shooting-star2"></div>
                <div className="shooting-star shooting-star3"></div>
                <div className="shooting-star shooting-star4"></div>
                <div className="shooting-star shooting-star5"></div>
                <div className="shooting-star shooting-star6"></div>
                <div className="shooting-star shooting-star7"></div>
                <div className="shooting-star shooting-star8"></div>
                <div className="shooting-star shooting-star9"></div>
                <div className="shooting-star shooting-star10"></div>
                
                {/* Sparkles */}
                <div className="sparkle sparkle1"></div>
                <div className="sparkle sparkle2"></div>
                <div className="sparkle sparkle3"></div>
                <div className="sparkle sparkle4"></div>
                <div className="sparkle sparkle5"></div>
                <div className="sparkle sparkle6"></div>
                <div className="sparkle sparkle7"></div>
                <div className="sparkle sparkle8"></div>
                <div className="sparkle sparkle9"></div>
                <div className="sparkle sparkle10"></div>
                <div className="sparkle sparkle11"></div>
                <div className="sparkle sparkle12"></div>
                <div className="sparkle sparkle13"></div>
                <div className="sparkle sparkle14"></div>
                
                {/* Purple particles */}
                <div className="purple-particle particle1"></div>
                <div className="purple-particle particle2"></div>
                <div className="purple-particle particle3"></div>
                <div className="purple-particle particle4"></div>
                <div className="purple-particle particle5"></div>
                <div className="purple-particle particle6"></div>
                <div className="purple-particle particle7"></div>
                <div className="purple-particle particle8"></div>
                <div className="purple-particle particle9"></div>
                <div className="purple-particle particle10"></div>
                <div className="purple-particle particle11"></div>
                <div className="purple-particle particle12"></div>
                <div className="purple-particle particle13"></div>
            </div>
            <Teams />
            <Members />
            {/* <Contact /> */}
        </div>
      );
    }
}